import React from "react";
import SimpleDialogComponent from "./SimpleDialogComponent";
import { useTranslation } from "react-i18next";
import { useLanguageProvider } from "../../providers/LanguageProvider";
import { Button, Grid } from "@mui/material";

const LanguageSelectorDialogComponent = ({ isOpen, onClose }) => {
  const { t, i18n } = useTranslation();
  const lang = useLanguageProvider();

  const onClickLang = (nextLanguage) => {
    var pathname = window.location.pathname;
    const splited = window.location.pathname.replace(/\/+$/, "").split("/");
    if (splited.length > 1 && splited[1] == i18n.language) {
      splited[1] = nextLanguage;
      pathname = splited.join("/");
    } else {
      pathname = `/${nextLanguage}${pathname}`;
    }

    window.location.replace(pathname);
  };

  return (
    <div>
      <SimpleDialogComponent
        open={isOpen}
        onClose={onClose}
        child={
          <Grid container spacing={2}>
            {lang.supportedLanguages.sort().map((code, i) => (
              <Grid key={i} item xs={3}>
                <Button
                  onClick={() => onClickLang(code.toLowerCase())}
                  color={
                    i18n.language == code.toLowerCase()
                      ? "primary"
                      : "textButton"
                  }
                  disableRipple
                >
                  {t(`lang_${code.toLowerCase()}_name`)}
                </Button>
              </Grid>
            ))}
          </Grid>
        }
        title={t("dialogChooseALanguage")}
      />
    </div>
  );
};

export default LanguageSelectorDialogComponent;
